import { PageContext } from 'pages/InstructorViewFormativeSubmission/PageProvider';
import { useContext } from 'react';
import { Button, Stack, styled } from 'shell/components';

const Footer = () => {
    const { studentSubmissionsGroupedByAccountUser, currentSubmission, onClickExit, onClickViewNext } =
        useContext(PageContext);

    const viewableStudents = studentSubmissionsGroupedByAccountUser.filter(({ submissions }) =>
        Boolean(submissions.length)
    );
    const nextStudentIndex =
        viewableStudents.findIndex(({ owner_account_id }) => owner_account_id === currentSubmission.owner_account_id) +
        1;
    const canViewNext = Boolean(viewableStudents[nextStudentIndex]);

    return (
        <CustomStack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
            <Button color={'neutral'} variant={'tertiary'} onClick={onClickExit}>
                Exit
            </Button>
            <Button disabled={!canViewNext} onClick={onClickViewNext}>
                View Next
            </Button>
        </CustomStack>
    );
};

const CustomStack = styled(Stack)(({ theme }) => {
    return {
        position: 'absolute',
        bottom: 0,
        borderTop: `1px solid ${theme.palette.ensightful.neutral[300]}`,
        width: '100%',
        height: '61px',
        padding: theme.spacing(3, 5),
        background: theme.palette.ensightful.primary[50],
    };
});

export default Footer;
